<template>
  <div class="content">
    <TopLogoSidebar></TopLogoSidebar>
    <div>
      <LeftMenuSidebar></LeftMenuSidebar>
      <div :class="['container', sidebarStore.isOpen ? 'container--sidebar-open' : 'container--sidebar-close']">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LeftMenuSidebar from "../sidebars/LeftMenuSidebar.vue";
import TopLogoSidebar from "../sidebars/TopLogoSidebar.vue";
import {useSidebarStore} from "@/store/sidebar/sidebar";

const sidebarStore = useSidebarStore();
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  width: 100%;
  height: 100%;
  padding-right: 12px;
  background-color: $page-background-color;
}

.container--sidebar-open {
  left: 252px;
  width: calc(100% - 264px);
}

.container--sidebar-close {
  left: 98px;
  width: calc(100% - 110px);
}

.container {
  position: absolute;
  top: 72px;
}
</style>
